import { render, staticRenderFns } from "./FluxWrapper.vue?vue&type=template&id=740fc428&"
import script from "./FluxWrapper.vue?vue&type=script&lang=js&"
export * from "./FluxWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports